import { render, staticRenderFns } from "./GsPage.vue?vue&type=template&id=95142190&scoped=true&"
import script from "./GsPage.vue?vue&type=script&lang=js&"
export * from "./GsPage.vue?vue&type=script&lang=js&"
import style0 from "./GsPage.vue?vue&type=style&index=0&id=95142190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95142190",
  null
  
)

export default component.exports